












import { mapGetters, mapState } from 'vuex';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';
import { ECopyStakeFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';

const CopyStakeAiStreamersTabsView = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAutoclicker/CopyStakeAiStreamersTabsView.vue'
  );

export default {
  name: 'CopyStakeAiStreamersView',
  components: {
    CopyStakeAiStreamersTabsView
  },
  mixins: [FeatureFlagRedirectMixin],
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    ...mapGetters('FeatureFlags', [
      'isEnabledFeatureFlag',
      'isAdminVisibleFeatureFlag'
    ]),
    isFeatureVisible(): boolean {
      const handler = this.isSuperAdmin
        ? this.isEnabledFeatureFlag
        : this.isAdminVisibleFeatureFlag;

      return handler(ECopyStakeFeatureFlag.COPYSTAKE_AUTOCLICKER);
    }
  }
};
